

















import Vue, { PropType } from "vue";
import log from "loglevel";
import fetch from "cross-fetch";

export interface GuidanceForAlreadyContractedUserProps {
  url: string;
  apiUrlBase: string;
}

export interface ContractSummaryResponse {
  is_gold_member?: boolean;
  has_clip_store_contract?: boolean;
  error?: string;
  error_description?: string;
}

export default Vue.extend({
  name: "vc-guidance-for-already-contracted-user",
  props: {
    url: {
      type: String as PropType<GuidanceForAlreadyContractedUserProps["url"]>,
      default: ""
    },
    apiUrlBase: {
      type: String as PropType<
        GuidanceForAlreadyContractedUserProps["apiUrlBase"]
      >,
      default: ""
    }
  },
  data: function() {
    return {
      isGoldMember: false,
      hasClipStoreContract: false,
      isDisplay: false
    };
  },
  mounted() {
    this.getContractSummary();
  },
  methods: {
    async getContractSummary() {
      try {
        let requestParams: { [key: string]: any } = {
          method: "GET",
          mode: "cors", //クロスオリジンリクエストをするのでCORSモードにする
          credentials: "include" //クレデンシャルを含める指定
        };
        // API たたくよ
        const response = await fetch(
          this.apiUrlBase + "/cross_origin/store_data/contract_summary",
          requestParams
        );
        // いまのところ 200 だけ
        if (response.status === 200) {
          let responseBody = (await response.json()) as ContractSummaryResponse;
          if ("error" in responseBody) {
            throw responseBody;
          }
          this.isDisplay = (responseBody.is_gold_member ||
            responseBody.has_clip_store_contract) as boolean;
        } else {
          this.isDisplay = false;
        }
      } catch (ex) {
        // clip-site 側のエラーの場合もここを通す
        log.error(ex);
        // 通信エラー等の場合は表示しない
        this.isDisplay = false;
      }
    }
  }
});
